module.exports = "/_next/static/images/T1_hires@2x-2d4c8dc2b03ba725fe79f9090e2efc07.png";